import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../../assets/locales/en';
import ru from '../../assets/locales/ru';
import { AppLang } from './types';
import { detectInitialLanguage } from './detect-language';

export const resources = {
  en: {
    translation: en,
  },
  ru: {
    translation: ru,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: detectInitialLanguage(),
  fallbackLng: AppLang.en,
});

export default i18n;
